import clsx from 'clsx';
import styles from './course.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getProblemById } from '~/api/problems';
import {
    createSubmissionTracking,
    getSubjectNameByClassID,
    getSubmissionTracking,
    getTopicProblem,
} from '~/api/courses';
import { getAllSubmissions, getSubmissionsByTopicProblemId } from '~/api/submissions';
import { getRole } from '~/api/auth';
import { getCurrentTimeFormatted } from '~/utils';

const { default: CourseViewDetailComponent } = require('~/components/CourseViewDetail');

const type_scores = { 0: 'Max Score', 1: 'Final Score', 2: 'Average Score' };

const MainChild = () => {
    const { id, problem_id, topic_problems_id } = useParams();
    const navigate = useNavigate();
    const [role, setRole] = useState('normal');

    const [problem, setProblem] = useState({
        id: 0,
        title: '',
        level_id: 0,
        level_name: '',
        description: '',
    });
    const [subjectName, setSubjectName] = useState('');
    const [topicProblems, setTopicProblems] = useState('');
    const [submissions, setSubmissions] = useState([]);
    const [allSubmissions, setAllSubmissions] = useState([]);
    const [submissionTrackings, setSubmissionTrackings] = useState([]);

    const convertDateFormat = (dateTimeString) => {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        const date = new Date(dateTimeString);
        const dayOfWeek = days[date.getUTCDay()];
        const dayOfMonth = date.getUTCDate();
        const month = months[date.getUTCMonth()];
        const year = date.getUTCFullYear();
        let hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const am_pm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // Chuyển giờ 0 thành 12

        return `${dayOfWeek}, ${dayOfMonth} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${am_pm}`;
    };

    const convertMinutesToHoursAndMinutes = (minutes) => {
        if (isNaN(minutes)) {
            return 'Invalid input';
        }

        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        if (hours === 0) {
            return `${remainingMinutes} minutes`;
        } else if (remainingMinutes === 0) {
            return `${hours} hours`;
        } else {
            return `${hours} hours ${remainingMinutes} minutes`;
        }
    };

    const handleNavigateToSubmissionTrackings = async () => {
        if (submissionTrackings.length > 0) {
            navigate(
                `/courses/${id}/submissionTrackings/${submissionTrackings[0].id}?problem_id=${problem_id}&topic_problems_id=${topic_problems_id}`,
            );
        } else {
            // Create a new submission trackings
            const response = await createSubmissionTracking({
                topic_problems_id,
                start_time: getCurrentTimeFormatted(),
                date_time: getCurrentTimeFormatted(),
            });
            console.log(response);
            navigate(
                `/courses/${id}/submissionTrackings/${response.body[0].id}?problem_id=${problem_id}&topic_problems_id=${topic_problems_id}`,
            );
        }
    };

    useEffect(() => {
        (async () => {
            const fetchRole = await getRole();
            setRole(fetchRole.body.role);
        })();
    }, []);

    useEffect(() => {
        const fetchRelevantName = async (id, problem_id, topic_problems_id) => {
            const res = await getProblemById(problem_id);
            setProblem(res.body);

            const fetchSubjectName = await getSubjectNameByClassID(id);
            setSubjectName(fetchSubjectName.body.subject_name);

            const fetchSubmissons = await getSubmissionsByTopicProblemId(topic_problems_id);
            setSubmissions(fetchSubmissons.body);

            const fetchSubmissonTrackings = await getSubmissionTracking(topic_problems_id);
            setSubmissionTrackings(fetchSubmissonTrackings.body);

            const fetchAllSubmissions = await getAllSubmissions(topic_problems_id);
            setAllSubmissions(fetchAllSubmissions.body);

            const fetchTopicProblems = await getTopicProblem(topic_problems_id);
            setTopicProblems(fetchTopicProblems.body);
            console.log(fetchTopicProblems.body);
        };

        fetchRelevantName(id, problem_id, topic_problems_id);
    }, [id, problem_id, topic_problems_id]);

    return (
        <div className={clsx(styles.waitingField)}>
            <div className={clsx(styles.timerField)}>
                <div className={clsx(styles.timerItem)}>
                    <span>Opened:</span> {convertDateFormat(topicProblems.start_time)}
                </div>
                <div className={clsx(styles.timerItem)}>
                    <span>Closed:</span> {convertDateFormat(topicProblems.end_time)}
                </div>
            </div>
            <div className="">
                {submissionTrackings && submissionTrackings.length > 0 && (
                    <div
                        className={clsx(styles.buttonCustom, styles.buttonSubmit)}
                        onClick={handleNavigateToSubmissionTrackings}
                    >
                        CONTINUE TO DO
                    </div>
                )}
                {submissionTrackings &&
                    submissionTrackings.length === 0 &&
                    submissions &&
                    submissions.length < topicProblems.retries && (
                        <div
                            className={clsx(styles.buttonCustom, styles.buttonSubmit)}
                            onClick={handleNavigateToSubmissionTrackings}
                        >
                            START DOING IT
                        </div>
                    )}
            </div>
            <div className={clsx(styles.timerField)}>
                <div className={clsx(styles.timerItem)}>
                    <span>Attempts allowed:</span> {topicProblems.retries}
                </div>
                <div className={clsx(styles.timerItem)}>
                    <span>Time limit:</span> {convertMinutesToHoursAndMinutes(topicProblems.time_limit)}
                </div>
                <div className={clsx(styles.timerItem)}>
                    <span>Grading method: </span> {type_scores[topicProblems.type_score]}
                </div>
            </div>
            <div className={clsx(styles.submissionsField)}>
                <div className={clsx(styles.submissionsHeader)}>
                    <div className={clsx('col-1')}>Order</div>
                    <div className={clsx('col-5')}>Status</div>
                    <div className={clsx('col-2')}>Language</div>
                    <div className={clsx('col-2', 'textCenter')}>Point / 10.00</div>
                    <div className={clsx('col-2', 'textCenter')}>Setting</div>
                </div>
                <div className={clsx(styles.submissionsBody)}>
                    {submissions.map((submission, indexOfSubmission) => {
                        return (
                            <div className={clsx(styles.submissionsRow)}>
                                <div className={clsx('col-1')}>{indexOfSubmission}</div>
                                <div className={clsx('col-5')}>
                                    <div>{submission['status'] === 'Solved' ? 'Completed' : 'Attempted'}</div>
                                </div>
                                <div className={clsx('col-2')}>
                                    <div className={clsx(styles.language)}>{submission['name']}</div>
                                </div>
                                <div className={clsx('col-2', 'textCenter')}>{submission['score'].toFixed(2)}</div>
                                <div className={clsx('col-2', 'textCenter')}>-</div>
                            </div>
                        );
                    })}
                    {submissionTrackings && submissionTrackings.length > 0 && (
                        <div className={clsx(styles.submissionsRow)}>
                            <div className={clsx('col-1')}>0</div>
                            <div className={clsx('col-5')}>In progressing...</div>
                            <div className={clsx('col-2')}>-</div>
                            <div className={clsx('col-1')}>-</div>
                            <div className={clsx('col-1')}>-</div>
                            <div className={clsx('col-2')}>-</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const WaitingField = () => {
    return <CourseViewDetailComponent state="exercise" mainChild={<MainChild />} />;
};

export default WaitingField;
